import jsPDF from "jspdf"
// import addFont from "../../../../fonts/fonts"
import 'jspdf-autotable'
import moment from "moment"
import addFont from "../../../../../assets/fonts/fonts"
import { MONTH_GENITIVE } from "../../../../../assets/const"
import { addJustifiedText } from "../../../../../utils/reportHelpers"


const orientation = 'p'

const CATEGORIES = [
  {value: 'first_passed', text: 'установлена первая квалификационная категория'},
  {value: 'higher_passed', text: 'установлена высшая квалификационная категория'},
  {value: 'first_failed', text: 'отказано в установлении первой квалификационной категории'},
  {value: 'higher_failed', text: 'отказано в установлении высшей квалификационной категории'},
]

export const getDecreeGuk = async ({data, comission, userInfo}) => {

  
  const dateFormatted = (date) => moment(date).format(`DD ${MONTH_GENITIVE[moment(date).month()]} YYYY`)
  const dateFormattedNew = (date) => moment(date).format(`"___" ${MONTH_GENITIVE[moment(date).month()]} YYYY`)
  
  const dateEndSimple = dateFormattedNew(comission?.date_to)
  const dateEndComission = dateFormatted(comission?.date_to)
  

  let lastY = 35
  let actualY
  let text
  let rows


  const getY = (indent, newValue) => {
    let newY = newValue ? newValue + indent : lastY + indent
    if (newY > doc.internal.pageSize.height - 30) {
      doc.addPage('a4', orientation)
      newY = 25
    }
    lastY = newY
    return newY
  }


  addFont(jsPDF.API)
  const doc = new jsPDF({ putOnlyUsedFonts: true, orientation: orientation })

  doc.setFont('TimesNewRoman', 'bold').setFontSize(46)
  
  doc.text('ПРИКАЗ', 105, lastY, 'center')
  
  doc.setFontSize(16)

  doc.text('НАЧАЛЬНИКА ГЛАВНОГО УПРАВЛЕНИЯ КАДРОВ', 105, getY(13), 'center')
  doc.text('МИНИСТЕРСТВА ОБОРОНЫ РОССИЙСКОЙ ФЕДЕРАЦИИ', 105, getY(6), 'center')
  
  doc.setFont(undefined, 'normal')
  
  doc.text(`${dateEndSimple}г. № _____`, 105, getY(13), 'center')
  doc.text('г. Москва', 105, getY(6), 'center')
  
  doc.setFont(undefined, 'bold')
  
  doc.text('О квалификационных категориях', 105, getY(17), 'center')
  doc.text('педагогических работников организаций, находящихся в ведении', 105, getY(6), 'center')
  doc.text('Министерства обороны Российской Федерации и осуществляющих', 105, getY(6), 'center')
  doc.text('образовательную деятельность', 105, getY(6), 'center')

  
  doc.setFont(undefined, 'normal')
  
  text = '          В целях установления соответствия уровня квалификации педагогических работников организаций, находящихся в ведении Министерства обороны Российской Федерации и осуществляющих образовательную деятельность, требованиям, предъявляемым к квалификационным категориям (первой или высшей), в соответствии с частью 3 статьи 49 Федерального закона от 29 декабря 2012 г. № 273-ФЗ «Об образовании в Российской Федерации», приказом Министерства просвещения Российской Федерации от 24 марта 2023г.'
  addJustifiedText(doc, text, 23, getY(17), 165, 6)
  
  text = '№ 196 «Об утверждении Порядка проведения аттестации педагогических работников организаций, осуществляющих образовательную деятельность», приказом Министра обороны Российской Федерации от 16 сентября 2011 г.'
  addJustifiedText(doc, text, 23, getY(56), 165, 6)
  
  text = '№ 1650 «Об аттестационных комиссиях Министерства обороны Российской Федерации по аттестации педагогических и руководящих работников федеральных государственных образовательных учреждений Министерства обороны Российской Федерации» и Инструкцией по проведению аттестации педагогических работников организаций, находящихся в ведении Министерства обороны Российской Федерации и осуществляющих образовательную деятельность, утвержденной статс-секретарем – заместителем Министра обороны Российской Федерации 22 июня 2023 г.,'
  addJustifiedText(doc, text, 23, getY(26), 165, 6)
  
  doc.setFont(undefined, 'bold')
  
  doc.text('ПРИКАЗЫВАЮ:', 43, 261)
  
  doc.setFont(undefined, 'normal')
  
  doc.text(`          1. Установить c ${dateEndComission}г.:`, 23, getY(70))
  
  text = '          первую квалификационную категорию педагогическим работникам организаций, находящихся в ведении Министерства обороны Российской Федерации и осуществляющих образовательную деятельность, согласно списку (приложение № 1 к настоящему приказу);'
  addJustifiedText(doc, text, 23, getY(10), 165, 6)
  
  text = '          высшую квалификационную категорию педагогическим работникам организаций, находящихся в ведении Министерства обороны Российской Федерации и осуществляющих образовательную деятельность, согласно списку (приложение № 2 к настоящему приказу).'
  addJustifiedText(doc, text, 23, getY(32), 165, 6)
  
  text = '          2. Контроль за выполнением настоящего приказа возложить на начальника управления военного образования – заместителя начальника Главного управления кадров Министерства обороны Российской Федерации.'
  addJustifiedText(doc, text, 23, getY(35), 165, 6)
  
  doc.setFont(undefined, 'bold')

  doc.text('ВРЕМЕННО ИСПОЛНЯЮЩИЙ ОБЯЗАННОСТИ', 105, getY(35), 'center')
  doc.text('НАЧАЛЬНИКА ГЛАВНОГО УПРАВЛЕНИЯ КАДРОВ', 105, getY(6), 'center')
  doc.text('МИНИСТЕРСТВА ОБОРОНЫ РОССИЙСКОЙ ФЕДЕРАЦИИ', 105, getY(6), 'center')
  doc.text('генерал-лейтенант', 105, getY(6), 'center')
  doc.text('Ю. Бобров', 160, getY(10))

  CATEGORIES.forEach((category, ind) => {
    doc.addPage('a4', orientation)
    lastY = 15
    
    doc.setFont(undefined, 'normal')
  
    doc.text(`Приложение № ${ind + 1}`, 132, lastY, 'center')
    doc.text('к приказу начальника Главного управления кадров', 132, getY(6), 'center')
    doc.text('Министерства обороны Российской Федерации', 132, getY(6), 'center')
    doc.text(`${dateEndSimple}г. № _____`, 132, getY(6), 'center')
  
    doc.setFont(undefined, 'bold').setFontSize(14)
  
    doc.text('СПИСОК', 105, getY(30), 'center')
    doc.text('педагогических работников', 105, getY(6), 'center')
    doc.text('организаций, находящихся в ведении Министерства обороны', 105, getY(6), 'center')
    doc.text('Российской Федерации и осуществляющих образовательную', 105, getY(6), 'center')
    doc.text(`деятельность, которым ${category.text}`, 105, getY(6), 'center')
  
    doc.setFontSize(16)

    Object.keys(data.data[category.value]).forEach((school, ind) => {
      
      const items = data.data[category.value][school]
      if (!items.length) return;
      
      doc.setFont(undefined, 'bold')
      const schoolLines = doc.splitTextToSize(school, 180)
      schoolLines.forEach((item, i) => doc.text(item, 105, getY(i ? 6 : ind ? 18 : 25), 'center'))
      doc.setFont(undefined, 'normal')
    
      items.forEach((item, ind) => {
        const fio = `${item.full_user_name || ''}, ${item.attestation_name || ''}.`
        doc.text(`${ind + 1}. ${fio}`, 23, getY(10))
      })
    })
    doc.text('___________', 105, getY(5), 'center')
  })

  
  doc.addPage('a4', orientation)
  doc.deletePage(doc.getNumberOfPages())
  return doc
}